import React from 'react';

import PageContext from '@zego/context/PageContext';

import Link from '@zego/components/Link';

export const EN_ITUNES_LINK = 'https://zegocover.app.link/0tezeYmFYR';
export const ES_ITUNES_LINK = 'https://zegocover.app.link/QhCtRBcSwT';

export const getAppStoreLinkFromLanguage = language => {
  switch (language) {
    case 'es':
      return ES_ITUNES_LINK;
    case 'en':
    default:
      return EN_ITUNES_LINK;
  }
};

const AppStoreLink = ({ children, ...other }) => (
  <PageContext.Consumer>
    {({ language }) => (
      <Link {...other} href={getAppStoreLinkFromLanguage(language)}>
        {children}
      </Link>
    )}
  </PageContext.Consumer>
);

export default AppStoreLink;
